import { createSelector } from "@reduxjs/toolkit";

const selectEventState = (state) => state.event || {};

export const selectEvents = createSelector(
  [selectEventState],
  (eventState) => eventState.events ?? [] // stable reference
);

export const selectSelectedEvent = createSelector(
  [selectEventState],
  (eventState) => eventState.selectedEvent ?? null
);

export const selectIsLoading = createSelector(
  [selectEventState],
  (eventState) => eventState.isLoading ?? false
);
